import type * as Types from '../../../../graphql';

import { gql } from '@apollo/client';
import { SampleTileFragmentDoc } from '../../../../modules/files/graphql/files-queries.gql';
import { MinimalSampleTileFragmentDoc } from './sample-fragments.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSampleInfoQueryVariables = Types.Exact<{
  sampleId: Types.Scalars['Long']['input'];
}>;


export type GetSampleInfoQuery = { sample: { sample: { id: number, name: string | null, description: string | null, created: string | null, modified: string | null, deleted: boolean | null, hidden: boolean, locked: boolean | null, status: { name: string, color: string | null } | null, type: { name: string } | null, project: { id: number, name: string, color: string | null } | null, submitter: { firstName: string | null, lastName: string | null, username: string | null } | null, receiver: { firstName: string | null, lastName: string | null, username: string | null } | null } | null } | null };

export type GetSampleTilesQueryVariables = Types.Exact<{
  sampleIds: Types.InputMaybe<Array<Types.Scalars['Long']['input']> | Types.Scalars['Long']['input']>;
}>;


export type GetSampleTilesQuery = { sample: { samples: Array<{ id: number, name: string | null, description: string | null, created: string | null, modified: string | null, deleted: boolean | null, hidden: boolean, locked: boolean | null, status: { name: string, color: string | null } | null, type: { name: string } | null, project: { id: number, name: string, color: string | null } | null } | null> | null } | null };

export type GetMinimalSampleTilesQueryVariables = Types.Exact<{
  sampleIds: Types.InputMaybe<Array<Types.Scalars['Long']['input']> | Types.Scalars['Long']['input']>;
}>;


export type GetMinimalSampleTilesQuery = { sample: { samples: Array<{ id: number, name: string | null, locked: boolean | null, hidden: boolean, deleted: boolean | null, type: { id: number, name: string } | null } | null> | null } | null };

export type UserDisplayNameFragment = { firstName: string | null, lastName: string | null, username: string | null };

export type ProjectColoredWidgetFragment = { id: number, name: string, color: string | null };

export const UserDisplayNameFragmentDoc = gql`
    fragment UserDisplayName on User {
  firstName
  lastName
  username
}
    `;
export const ProjectColoredWidgetFragmentDoc = gql`
    fragment ProjectColoredWidget on Project {
  id
  name
  color
}
    `;
export const GetSampleInfoDocument = gql`
    query getSampleInfo($sampleId: Long!) {
  sample {
    sample(sampleId: $sampleId) {
      id
      name
      description
      status {
        name
        color
      }
      type {
        name
      }
      created
      modified
      project {
        ...ProjectColoredWidget
      }
      deleted
      hidden
      submitter {
        ...UserDisplayName
      }
      receiver {
        ...UserDisplayName
      }
      locked
    }
  }
}
    ${ProjectColoredWidgetFragmentDoc}
${UserDisplayNameFragmentDoc}`;

/**
 * __useGetSampleInfoQuery__
 *
 * To run a query within a React component, call `useGetSampleInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSampleInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSampleInfoQuery({
 *   variables: {
 *      sampleId: // value for 'sampleId'
 *   },
 * });
 */
export function useGetSampleInfoQuery(baseOptions: Apollo.QueryHookOptions<GetSampleInfoQuery, GetSampleInfoQueryVariables> & ({ variables: GetSampleInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSampleInfoQuery, GetSampleInfoQueryVariables>(GetSampleInfoDocument, options);
      }
export function useGetSampleInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSampleInfoQuery, GetSampleInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSampleInfoQuery, GetSampleInfoQueryVariables>(GetSampleInfoDocument, options);
        }
export function useGetSampleInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSampleInfoQuery, GetSampleInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSampleInfoQuery, GetSampleInfoQueryVariables>(GetSampleInfoDocument, options);
        }
export type GetSampleInfoQueryHookResult = ReturnType<typeof useGetSampleInfoQuery>;
export type GetSampleInfoLazyQueryHookResult = ReturnType<typeof useGetSampleInfoLazyQuery>;
export type GetSampleInfoSuspenseQueryHookResult = ReturnType<typeof useGetSampleInfoSuspenseQuery>;
export type GetSampleInfoQueryResult = Apollo.QueryResult<GetSampleInfoQuery, GetSampleInfoQueryVariables>;
export const GetSampleTilesDocument = gql`
    query getSampleTiles($sampleIds: [Long!]) {
  sample {
    samples(sampleIds: $sampleIds) {
      ...SampleTile
    }
  }
}
    ${SampleTileFragmentDoc}`;

/**
 * __useGetSampleTilesQuery__
 *
 * To run a query within a React component, call `useGetSampleTilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSampleTilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSampleTilesQuery({
 *   variables: {
 *      sampleIds: // value for 'sampleIds'
 *   },
 * });
 */
export function useGetSampleTilesQuery(baseOptions?: Apollo.QueryHookOptions<GetSampleTilesQuery, GetSampleTilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSampleTilesQuery, GetSampleTilesQueryVariables>(GetSampleTilesDocument, options);
      }
export function useGetSampleTilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSampleTilesQuery, GetSampleTilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSampleTilesQuery, GetSampleTilesQueryVariables>(GetSampleTilesDocument, options);
        }
export function useGetSampleTilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSampleTilesQuery, GetSampleTilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSampleTilesQuery, GetSampleTilesQueryVariables>(GetSampleTilesDocument, options);
        }
export type GetSampleTilesQueryHookResult = ReturnType<typeof useGetSampleTilesQuery>;
export type GetSampleTilesLazyQueryHookResult = ReturnType<typeof useGetSampleTilesLazyQuery>;
export type GetSampleTilesSuspenseQueryHookResult = ReturnType<typeof useGetSampleTilesSuspenseQuery>;
export type GetSampleTilesQueryResult = Apollo.QueryResult<GetSampleTilesQuery, GetSampleTilesQueryVariables>;
export const GetMinimalSampleTilesDocument = gql`
    query getMinimalSampleTiles($sampleIds: [Long!]) {
  sample {
    samples(sampleIds: $sampleIds) {
      ...MinimalSampleTile
    }
  }
}
    ${MinimalSampleTileFragmentDoc}`;

/**
 * __useGetMinimalSampleTilesQuery__
 *
 * To run a query within a React component, call `useGetMinimalSampleTilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMinimalSampleTilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMinimalSampleTilesQuery({
 *   variables: {
 *      sampleIds: // value for 'sampleIds'
 *   },
 * });
 */
export function useGetMinimalSampleTilesQuery(baseOptions?: Apollo.QueryHookOptions<GetMinimalSampleTilesQuery, GetMinimalSampleTilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMinimalSampleTilesQuery, GetMinimalSampleTilesQueryVariables>(GetMinimalSampleTilesDocument, options);
      }
export function useGetMinimalSampleTilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMinimalSampleTilesQuery, GetMinimalSampleTilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMinimalSampleTilesQuery, GetMinimalSampleTilesQueryVariables>(GetMinimalSampleTilesDocument, options);
        }
export function useGetMinimalSampleTilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMinimalSampleTilesQuery, GetMinimalSampleTilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMinimalSampleTilesQuery, GetMinimalSampleTilesQueryVariables>(GetMinimalSampleTilesDocument, options);
        }
export type GetMinimalSampleTilesQueryHookResult = ReturnType<typeof useGetMinimalSampleTilesQuery>;
export type GetMinimalSampleTilesLazyQueryHookResult = ReturnType<typeof useGetMinimalSampleTilesLazyQuery>;
export type GetMinimalSampleTilesSuspenseQueryHookResult = ReturnType<typeof useGetMinimalSampleTilesSuspenseQuery>;
export type GetMinimalSampleTilesQueryResult = Apollo.QueryResult<GetMinimalSampleTilesQuery, GetMinimalSampleTilesQueryVariables>;